export default function () {
    return {
        selectedReceiptLogUnit: {},
    };
}
